import { Modal, Spin } from "antd";
import MarkRecord from "pages/exam/supervise/components/SuperviseTable/component/RecordModal/component/MarkRecord";
import StudentInfo from "pages/exam/supervise/components/SuperviseTable/component/RecordModal/component/StudentInfo";
import React from "react";
import { useParams } from "react-router-dom";
import { getExamInfoByStu } from "service/exam";
import useRequest from "utils/useRequest";
import style from "./index.module.scss";

interface MarkModalProps {}
export default function RecordModal({ ...restProps }: MarkModalProps) {
    const { examId, studentNo, ban } = useParams<{
        examId: string;
        studentNo: string;
        ban: string;
    }>();
    const [data, { loading }, updateExamInfo] = useRequest(
        () => getExamInfoByStu(examId, studentNo),
        {},
        [examId, studentNo]
    );

    return (
        <Modal
            {...restProps}
            title="查看监考详情"
            className={style.root}
            width={940}
            maskClosable={false}
            footer={null}>
            <Spin spinning={loading}>
                <div className={style.container}>
                    <div className={style.left}>
                        {data && <StudentInfo data={data} ban={ban} />}
                    </div>
                    <div className={style.right}>
                        <div className={style.title}>考生基本信息</div>
                        {data && (
                            <MarkRecord
                                data={data}
                                updateExamInfo={updateExamInfo}
                                studentNo={studentNo}
                            />
                        )}
                    </div>
                </div>
            </Spin>
        </Modal>
    );
}
